import React, { useContext, useState } from "react";
import AuthContext from "../../context/auth/authContext";
import AdminemailLogsContext from "../../context/adminemailLogs/adminemailLogsContext";
import moment from "moment";
import * as FaIcons from "react-icons/fa";
import { getReactAppUrl,getAppUrl } from "../../functions/getEnv";
import axios from "axios";
import ForwardEmailModal from "./ForwardEmailModal";


const EmailLoggerRow = ({
  info: {
    _id,
    createdAt,
    recipientEmail,
    relatedRecordId,
    recordType,
    emailType,
    learningCenterName,
    learningCenterAddress,
    status,
    fromEmail,
    errorMessage,
    id = _id,
  },
  history,
  visibleColumns,
}) => {
	const appUrl = getAppUrl(import.meta.env.VITE_NODE_ENV);

  const [copiedId, setCopiedId] = useState(null);
  const [resendLoading, setResendLoading] = useState(false);
  const [forwardModalOpen, setForwardModalOpen] = useState(false);
  const [forwardLoading, setForwardLoading] = useState(false);
  const authContext = useContext(AuthContext);
  const { loadUser, user } = authContext;
  const userStatus = user?.userStatus || null;

  const adminemailLogsContext = useContext(AdminemailLogsContext);
  const { getEntries } = adminemailLogsContext;

  // Helper function to check if column is visible
  const isColumnVisible = (columnName) => {
    if (!visibleColumns) return true;
    return visibleColumns[columnName] !== false;
  };

  const formatEmails = (emails) => {
    if (!emails || emails.length === 0) return "N/A";
    if (Array.isArray(emails)) {
      return emails.join(", ");
    }
    return emails;
  };

  const getStatusStyle = (status) => {
    switch (status?.toLowerCase()) {
      case 'sent':
        return { color: '#537131', fontWeight: '600' };
      case 'failed':
        return { color: '#dc3545', fontWeight: '600' };
      case 'pending':
        return { color: '#ffc107', fontWeight: '600' };
      default:
        return { color: '#6c757d', fontWeight: '600' };
    }
  };

  const handleForward = async (toEmails, ccEmails,bccEmails) => {
    try {
      setForwardLoading(true);
      const resp = await axios.post(`${appUrl}/api/emaillogs/${_id}/forward`, {
        toEmails,
        ccEmails,
        bccEmails,
        domain: window.location.origin,
        EnrollmentsUrl: window.location.origin,
      });

      if (resp && resp.status === 200) {
        alert("Email forwarded successfully! A new log entry has been created.");

        if (getEntries) {
          await getEntries();
        }
      } else {
        console.error("Unexpected forward response", resp);
        alert("Failed to forward email. See console for details.");
      }
    } catch (err) {
      console.error("Forward error:", err.response || err.message || err);
      alert("Failed to forward email. Check console or try again later.");
      throw err;
    } finally {
      setForwardLoading(false);
    }
  };

  return (
    <>
      <ForwardEmailModal
        isOpen={forwardModalOpen}
        onClose={() => setForwardModalOpen(false)}
        onForward={handleForward}
        originalRecipient={recipientEmail}
      />
      <tr
        onClick={() => {
          history.push(`/email-logger/${_id || id}`);
        }}>
        {isColumnVisible("createdAt") && <td>{moment(createdAt).format("MM/DD/YYYY")}</td>}
        {isColumnVisible("learningCenterName") && <td>{learningCenterName}</td>}
        {isColumnVisible("fromEmail") && <td>{fromEmail}</td>}
        {isColumnVisible("recipientEmail") && <td title={formatEmails(recipientEmail)}>{formatEmails(recipientEmail)}</td>}
        {isColumnVisible("emailType") && <td>{emailType}</td>}
        {isColumnVisible("relatedRecordId") && <td>{relatedRecordId}</td>}
        {isColumnVisible("errorMessage") && <td>{errorMessage}</td>}
        {isColumnVisible("status") && (
          <td>
            <span style={getStatusStyle(status)}>
              {status || "N/A"}
            </span>
          </td>
        )}
        {isColumnVisible("actions") && (
          <td>
            <div style={{ display: 'flex', gap: '6px', justifyContent: 'center' }}>
              <button
                className="btn btn-sm btn-llac-dark-green"
                disabled={resendLoading || forwardLoading}
                title="Resend Email"
                style={{
                  padding: '4px 8px',
                  fontSize: '14px',
                  minWidth: 'auto'
                }}
                onClick={async (e) => {
                  e.stopPropagation();

                  const confirmed = window.confirm(
                    `Are you sure you want to resend this email to ${recipientEmail}?\n\nClick OK to resend, or Cancel to go back.`
                  );

                  if (!confirmed) {
                    return;
                  }

                  try {
                    setResendLoading(true);
                    const resp = await axios.post(`${appUrl}/api/emaillogs/${_id}/resend`, {
                      domain: window.location.origin,
                      EnrollmentsUrl: window.location.origin,
                    });

                    if (resp && resp.status === 200) {
                      alert("Email resent successfully! A new log entry has been created.");

                      if (getEntries) {
                        await getEntries();
                      }
                    } else {
                      console.error("Unexpected resend response", resp);
                      alert("Failed to resend email. See console for details.");
                    }
                  } catch (err) {
                    console.error("Resend error:", err.response || err.message || err);
                    alert("Failed to resend email. Check console or try again later.");
                  } finally {
                    setResendLoading(false);
                  }
                }}
              >
                {resendLoading ? <FaIcons.FaPaperPlane     className="fa-spin" /> : <FaIcons.FaPaperPlane     />}
              </button>

              <button
                className="btn btn-sm btn-llac-blue"
                disabled={resendLoading || forwardLoading}
                title="Forward Email"
                style={{
                  padding: '4px 8px',
                  fontSize: '14px',
                  minWidth: 'auto'
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  setForwardModalOpen(true);
                }}
              >
                {forwardLoading ? <FaIcons.FaSpinner  className="fa-spin" /> : <FaIcons.FaShareSquare style={{ color: 'white' }} />}
              </button>
            </div>
          </td>
        )}
      </tr>
    </>
  );
};

export default EmailLoggerRow;
